
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetotelanganacabbooking() {



    const cardData =
    {
        keyword: 'Pune to Telangana Cab Booking ',
        heading: 'Platinum24 Cabs: Pune to Telangana Cab Booking',
        headingDescription: ' Platinum24 Cabs provides dependable Pune to Telangana cab booking services, ideal for families, pilgrims, business travelers, and tourists. Whether you’re traveling to Hyderabad for IT work, visiting Yadadri Temple, exploring Warangal Fort, or planning trips across Telangana’s cultural and spiritual hubs, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey. With skilled chauffeurs, punctual pickups, and transparent pricing, we make intercity travel hassle-free. From one-way drops to customized packages, Platinum24 Cabs guarantees reliable service and a pleasant Pune to Telangana travel experience.',

        top: 'Top Places to Visit in Telangana with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Charminar, Hyderabad",
    "description": "Charminar, built in 1591 by Muhammad Quli Qutb Shah, is Telangana’s most iconic monument. Its four grand minarets and Indo-Islamic architecture symbolize Hyderabad’s heritage. Surrounding Laad Bazaar is famous for bangles and pearls. The monument looks stunning when lit at night. Tourists flock here for history and shopping. Charminar is Telangana’s timeless cultural landmark."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort, once the capital of the Qutb Shahi dynasty, is an architectural marvel. Known for its unique acoustics and massive gateways, it was the seat of the famous diamond trade, including the Kohinoor. Evening sound-and-light shows narrate its history. Visitors explore palaces, mosques, and bastions within the fort. Its hilltop views of Hyderabad are breathtaking. Golconda Fort is Telangana’s royal heritage site."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City, the world’s largest film studio complex, is a must-visit near Hyderabad. Spread across 2,000 acres, it features movie sets, theme parks, gardens, and adventure zones. Families enjoy guided tours, shows, and film-themed attractions. It is also a popular shooting spot for Bollywood and Tollywood films. The experience blends cinema with entertainment. Ramoji Film City is Telangana’s entertainment paradise."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake, built in 1563, is a heart-shaped lake connecting Hyderabad and Secunderabad. Its centerpiece is the giant Buddha statue on Gibraltar Rock. Boating, laser shows, and Tank Bund promenade attract visitors. The Necklace Road area is vibrant with restaurants and parks. Evening views with city lights are magical. Hussain Sagar is Telangana’s serene urban lakefront."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir in Hyderabad is a pristine white marble temple dedicated to Lord Venkateswara. Built on a hillock, it offers panoramic views of the city. The temple blends Dravidian, Rajasthani, and Utkala architectural styles. Its peaceful ambiance attracts devotees and tourists alike. At night, the temple glows beautifully under lights. Birla Mandir is Telangana’s spiritual hilltop shrine."
  },
  {
    "title": "Warangal Fort",
    "description": "Warangal Fort, dating back to the 13th century Kakatiya dynasty, is a UNESCO heritage site. It is known for its massive stone gateways called Kirti Toranas. Intricate carvings and ruins showcase Kakatiya art. The fort complex includes temples and lakes. History lovers admire its grandeur and resilience. Warangal Fort is Telangana’s majestic historic monument."
  },
  {
    "title": "Thousand Pillar Temple, Hanamkonda",
    "description": "The Thousand Pillar Temple, built in the 12th century by the Kakatiyas, is an architectural marvel. Dedicated to Shiva, Vishnu, and Surya, it features intricately carved pillars and sculptures. Nandi’s massive monolith is a highlight. The temple reflects Telangana’s rich cultural and spiritual heritage. Pilgrims and tourists alike admire its beauty. Thousand Pillar Temple is Telangana’s sacred architectural gem."
  },
  {
    "title": "Kuntala Waterfalls",
    "description": "Kuntala Waterfalls, the highest in Telangana at 147 feet, is located in Adilabad district. Surrounded by dense forests, it is ideal for monsoon visits. Legends link it to Shakuntala and King Dushyanta. Trekking paths lead to the base, where the gushing waters are mesmerizing. Picnics and photography here are popular. Kuntala is Telangana’s majestic natural wonder."
  },
  {
    "title": "Nagarjuna Sagar Dam",
    "description": "Nagarjuna Sagar Dam, built on the Krishna River, is one of the largest masonry dams in the world. It offers stunning views of gushing waters and green landscapes. The reservoir also houses Nagarjunakonda Island with Buddhist relics and a museum. Boat rides to the island enrich the experience. It is both an engineering and cultural marvel. Nagarjuna Sagar is Telangana’s heritage reservoir attraction."
  },
  {
    "title": "Bhadrachalam Temple",
    "description": "Bhadrachalam Temple, located on the banks of the Godavari, is dedicated to Lord Rama. Built in the 17th century, it is linked to saint-poet Kancherla Gopanna (Bhakta Ramadasu). The temple is a major pilgrimage site, especially during Sri Rama Navami. Its spiritual aura attracts lakhs of devotees annually. Scenic river views add to its charm. Bhadrachalam is Telangana’s divine Ramayana destination."
  }
],


                          "services": [
    {
      "name": "Pune to Telangana Cab",
      "description": "Travel comfortably and safely from Pune to Telangana with our dedicated Pune to Telangana Cab service. Whether you're visiting for business, leisure, or family trips, our fleet of well-maintained vehicles ensures a smooth and hassle-free journey. Our professional drivers are experienced in long-distance travel and are well-acquainted with the routes between Pune and Telangana, prioritizing your safety and comfort. We offer door-to-door service with flexible scheduling and multiple vehicle options, including sedans and SUVs, to suit your travel needs and group size."
    },
    {
      "name": "Book Pune to Telangana Taxi",
      "description": "Booking your taxi from Pune to Telangana is now easier than ever with our user-friendly online platform. Simply select your vehicle, schedule, and pickup location, and receive instant confirmation. Our customer support team is available 24/7 to assist you with any special requests or travel queries. Enjoy reliable, punctual, and affordable transportation tailored to your schedule, making your Pune to Telangana trip stress-free and convenient. Whether traveling solo or in a group, our taxi service offers an excellent blend of comfort and efficiency."
    },
    {
      "name": "Pune to Hyderabad Telangana Cab",
      "description": "Experience seamless travel from Pune to Hyderabad with our specialized Pune to Hyderabad Telangana Cab service. We understand the importance of timely and comfortable rides, especially for business travelers and tourists. Our fleet includes air-conditioned vehicles equipped with modern amenities to enhance your journey. Skilled drivers navigate the best routes to avoid traffic and delays, ensuring you reach your destination refreshed and on time. Whether you require a one-way trip or round-trip service, our Hyderabad Telangana cab is your trusted travel partner."
    },
    {
      "name": "Pune to Telangana Outstation Cab",
      "description": "Our Pune to Telangana Outstation Cab service is designed for long-distance travelers who demand quality and dependability. We provide spacious, sanitized vehicles suitable for family trips, corporate travel, and group excursions. Our drivers are trained for highway driving and prioritize passenger safety throughout the journey. Enjoy flexible pickup and drop-off options along with transparent pricing. Our service covers all major cities and towns across Telangana, making your intercity travel comfortable and stress-free."
    },
    {
      "name": "Pune to Telangana One Way Taxi",
      "description": "Opt for our Pune to Telangana One Way Taxi for a cost-effective and convenient travel option when you need a one-direction journey. Perfect for business trips, family visits, or relocation, this service offers fixed pricing with no hidden charges. Our drivers ensure timely pickups and smooth rides, and our vehicles are well-maintained for safety and comfort. Book your one-way taxi with confidence knowing that your trip from Pune to Telangana will be handled professionally and efficiently."
    },
    {
      "name": "Telangana to Pune Cab Booking",
      "description": "Planning a return trip? Our Telangana to Pune Cab Booking service offers seamless transportation from Telangana back to Pune. Whether you're finishing a business trip, holiday, or family visit, our vehicles and drivers are ready to provide a safe, comfortable, and timely journey. Easily book your cab online or through our customer support, and enjoy the same quality and convenience as your onward trip. We prioritize punctuality and customer satisfaction for every ride."
    },
    {
      "name": "Pune to Telangana Taxi Fare",
      "description": "We offer transparent and competitive Pune to Telangana Taxi Fare packages that cater to various budgets without compromising service quality. Our fare includes all taxes, tolls, and driver allowances, so there are no hidden costs or surprises. Frequent travelers can benefit from seasonal discounts and special promotions. With upfront pricing, you can plan your trip confidently, ensuring excellent value for a reliable, safe, and comfortable ride between Pune and Telangana."
    },
    {
      "name": "Pune to Telangana Car Rental",
      "description": "Enjoy flexible travel options with our Pune to Telangana Car Rental service, available with or without a driver. Our rental fleet consists of well-maintained, fuel-efficient vehicles suitable for short or extended trips. Whether you’re on a family vacation, corporate trip, or personal journey, our car rental options provide convenience and freedom to explore at your own pace. We offer easy booking, transparent pricing, and customer support to ensure a smooth rental experience from start to finish."
    },
    {
      "name": "Affordable Pune to Telangana Cabs",
      "description": "Travel affordably without compromising comfort or safety with our Affordable Pune to Telangana Cabs. Designed for budget-conscious travelers such as students, professionals, and families, our economical options deliver reliable and comfortable transportation. All vehicles undergo regular maintenance and sanitation, and our professional drivers ensure safe travel. Take advantage of our competitive pricing, seasonal offers, and easy booking processes to make your journey from Pune to Telangana both pleasant and cost-effective."
    }
  ],
  "tableData": [
    ["Pune to Telangana Cab", "Book Pune to Telangana Taxi"],
    ["Pune to Hyderabad Telangana Cab", "Pune to Telangana Outstation Cab"],
    ["Pune to Telangana One Way Taxi", "Telangana to Pune Cab Booking"],
    ["Pune to Telangana Taxi Fare", "Pune to Telangana Car Rental"],
    ["Affordable Pune to Telangana Cabs"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Telangana Cab Booking",
    "WhyChoosedescription": "Platinum24 Cabs offers dependable and comfortable cab booking services for your journey from Pune to Telangana, ensuring a smooth travel experience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Fit Your Travel Needs",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers suitable for your Pune to Telangana trip."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe and hygienic environment during your Pune to Telangana journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Telangana Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune and Telangana for timely and hassle-free travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares that include fuel, tolls, and driver allowances for worry-free Pune to Telangana cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with your Pune to Telangana cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to Your Needs",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans customized for your Pune to Telangana travel."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Telangana cab quickly and securely via our website or app with immediate confirmation."
  }
]






























    }

    
const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Telangana cab services?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services from Pune to Telangana with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Telangana?',
        answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Telangana travel?',
        answer: 'We provide hatchbacks, sedans, SUVs, and luxury cars to suit your travel preferences and group size.',
    },
    {
        question: 'Is one-way cab service available from Pune to Telangana?',
        answer: 'Yes, both one-way and round-trip cab services are available for Pune to Telangana travel.',
    },
    {
        question: 'Are the drivers experienced for Pune to Telangana long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, professional, and familiar with the Pune to Telangana route.',
    },
    {
        question: 'Can I customize pickup and drop-off locations in Pune and Telangana?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points according to your convenience.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Telangana cabs?',
        answer: 'All vehicles are regularly sanitized, and drivers adhere to strict safety and hygiene measures to ensure passenger safety.',
    },
    {
        question: 'Is Pune to Telangana cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Telangana cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Telangana cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and major credit/debit cards for hassle-free payments.',
    },
    {
        question: 'Are customizable packages available for Pune to Telangana cab service?',
        answer: 'Yes, we offer flexible and customizable packages tailored to your travel itinerary and preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ravi Kumar',
        feedback: 'Great service and comfortable ride for my Pune to Telangana trip with Platinum24 Cabs.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Swathi Reddy',
        feedback: 'Highly recommend Platinum24 Cabs for their punctuality and professional drivers.',
        rating: 5,
    },
];


















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToTelanganaCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Telangana Cab Booking",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-telangana-cab.jpg",
  "description": "Book Pune to Telangana cab service with Platinum24 Cabs. Affordable, reliable taxis for Hyderabad and other Telangana destinations. Enjoy comfortable one-way and outstation rides with professional drivers and 24/7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-telangana-cab-booking"
  }
};





    return (
        <div>



<Helmet>
  <title>Pune to Telangana Cab Booking | Affordable Hyderabad Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Telangana cab service with Platinum24 Cabs. Affordable, reliable taxis for Hyderabad and other Telangana destinations. Enjoy comfortable one-way and outstation rides with professional drivers and 24/7 support."
  />
  <meta
    name="keywords"
    content="Pune to Telangana Cab, Book Pune to Telangana Taxi, Pune to Hyderabad Telangana Cab, Pune to Telangana Outstation Cab, Pune to Telangana One Way Taxi, Telangana to Pune Cab Booking, Pune to Telangana Taxi Fare, Pune to Telangana Car Rental, Affordable Pune to Telangana Cabs"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToTelanganaCabSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/115.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetotelanganacabbooking;